import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CreditFacilityPayoutFilterParams, CreditFacilityPayoutListItemModel, CreditFacilityPayoutModel, PagedListItems } from '../types'

interface CreditFacilityPayoutState {
    loading: boolean
    payoutDetails: CreditFacilityPayoutModel | null
    payoutsOnPage: CreditFacilityPayoutListItemModel[]
    pageIndex: number
    totalCount: number
    pageSize: number 
    payoutCreditFacilityId: string | null
    searchTerm: string | null
    error: Error | string | null
}

const initialState: CreditFacilityPayoutState = {
    loading: false,
    payoutDetails: null,
    payoutsOnPage: [],
    totalCount: 0,
    pageIndex: 1,
    pageSize: 20,
    payoutCreditFacilityId: null,
    searchTerm: null,
    error: null
}

export const creditFacilityPayoutSlice = createSlice({
    name: 'creditFacilityPayout',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        creditFacilityPayoutsFetched: (state, action: PayloadAction<PagedListItems<CreditFacilityPayoutListItemModel>>) => {
            state.loading = false
            state.payoutsOnPage = action.payload.items
            state.totalCount = action.payload.totalCount
            state.error = null
        },
        creditFacilityPayoutFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        creditFacilityPayoutDetailsFetched: (state, action: PayloadAction<CreditFacilityPayoutModel>) => {
            state.loading = false
            state.payoutDetails = action.payload
            state.error = null
        },
        creditFacilityPayoutsFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        },
        pageIndexChanged: (state, action: PayloadAction<number>) => {
            state.pageIndex = action.payload
        },
        filterChanged: (state, action: PayloadAction<CreditFacilityPayoutFilterParams>) => {
            state.searchTerm = action.payload.searchTerm
            state.payoutCreditFacilityId = action.payload.payoutCreditFacilityId
            state.pageIndex = 1
        },
    }
})

export const { 
    loading, 
    creditFacilityPayoutsFetched, 
    creditFacilityPayoutFetchFailure, 
    creditFacilityPayoutDetailsFetched, 
    creditFacilityPayoutsFetchFailure, 
    pageIndexChanged, 
    filterChanged 
} = creditFacilityPayoutSlice.actions

export default creditFacilityPayoutSlice.reducer
